import { render, staticRenderFns } from "./suppliersTable.vue?vue&type=template&id=04e8dbf6&"
import script from "./suppliersTable.vue?vue&type=script&lang=js&"
export * from "./suppliersTable.vue?vue&type=script&lang=js&"
import style0 from "./suppliersTable.vue?vue&type=style&index=0&id=04e8dbf6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports